export class FilespaceTokenManager {
    filespaceTokens = new Map();
    workspaceToFilespaceMap = new Map();
    setTokenManager(workspaceId, entityId, tokenManager) {
        if (this.filespaceTokens.get(entityId)) {
            return;
        }
        this.filespaceTokens.set(entityId, { workspaceId, tokenManager });
        let workspaceData = this.workspaceToFilespaceMap.get(workspaceId);
        if (!workspaceData) {
            workspaceData = [];
            this.workspaceToFilespaceMap.set(workspaceId, workspaceData);
        }
        workspaceData.push(entityId);
    }
    removeTokenManager(entityId) {
        const filespaceInfo = this.filespaceTokens.get(entityId);
        if (!filespaceInfo) {
            return;
        }
        this.filespaceTokens.delete(entityId);
        const workspaceInfo = this.workspaceToFilespaceMap.get(filespaceInfo.workspaceId);
        const filespaceIdx = workspaceInfo.indexOf(entityId);
        workspaceInfo.splice(filespaceIdx, 1);
        if (workspaceInfo.length === 0) {
            this.workspaceToFilespaceMap.delete(filespaceInfo.workspaceId);
        }
    }
    getTokenManager(entityId) {
        return this.filespaceTokens.get(entityId)?.tokenManager;
    }
    listFilespacesForWorkspace(workspaceId) {
        const entitieIds = this.workspaceToFilespaceMap.get(workspaceId);
        return entitieIds ? [...entitieIds] : [];
    }
}
